import { t } from '@lingui/macro';

import type { Column } from '@decisiv/ui-components/lib/components/Table/types';
import type { SortingTypes } from '@decisiv/ui-components/lib/components/Table';
import { sortFactory } from 'utils/sortFactory';
import type { ManagedFleet } from '.';

import OemSegmentNameCell from './Cells/OemSegmentNameCell';
import SentinelTeamNameCell from './Cells/SentinelTeamNameCell';
import PlatformAccountNameCell from './Cells/PlatformAccountNameCell';
import PlatformAccountSourceIdCell from './Cells/PlatformAccountSourceIdCell';
import AssetsCell from './Cells/AssetsCell';
import DepotsCell from './Cells/DepotsCell';
import CityCell from './Cells/CityCell';
import StateCell from './Cells/StateCell';
import ActionsCell from './Cells/ActionsCell';

interface GenerateColumnsParams {
  onSort: (fieldName: string, direction: SortingTypes) => void;
  amountOfOemSegmentsManaged: number;
}

export const generateColumns = ({
  onSort,
  amountOfOemSegmentsManaged,
}: GenerateColumnsParams) => {
  return [
    ...(amountOfOemSegmentsManaged > 1
      ? [
          {
            name: 'oemSegmentName',
            title: t`OEM Segment Name`,
            DataCell: OemSegmentNameCell,
            sortBy: sortFactory('oemSegmentName', onSort),
          },
        ]
      : []),
    {
      name: 'teamName',
      title: t`Team Name`,
      DataCell: SentinelTeamNameCell,
      sortBy: sortFactory('teamName', onSort),
    },
    {
      name: 'accountName',
      title: t`Account Name`,
      DataCell: PlatformAccountNameCell,
      sortBy: sortFactory('name', onSort),
    },
    {
      name: 'accountId',
      title: t`Account ID`,
      DataCell: PlatformAccountSourceIdCell,
      sortBy: sortFactory('sourceId', onSort),
    },
    {
      name: 'depots',
      title: t`Depots`,
      DataCell: DepotsCell,
      sortBy: sortFactory('enabledAssetGroupingsCount', onSort),
    },
    {
      name: 'assets',
      title: t`Assets`,
      DataCell: AssetsCell,
      sortBy: sortFactory('enabledAssetsCount', onSort),
    },
    {
      name: 'city',
      title: t`City`,
      DataCell: CityCell,
      sortBy: sortFactory('city', onSort),
    },
    {
      name: 'state',
      title: t`State`,
      DataCell: StateCell,
      sortBy: sortFactory('state', onSort),
    },
    {
      name: 'actions',
      title: t`Actions`,
      DataCell: ActionsCell,
    },
  ] satisfies Column<ManagedFleet>[];
};
